import instance from "./BasebBloomreachApi";

export function validateBloomreachCredentials(data) {
  return instance.request({
    url: `validate-credentials/`,
    method: "POST",
    data,
  });
}

export function updateBloomreachCredentials(data) {
  return instance.request({
    url: `update-credentials/`,
    method: "POST",
    data,
  });
}

export function saveBloomreachMappings(data) {
  return instance.request({
    url: `save-mappings/`,
    method: "POST",
    data,
  });
}

export function getBloomreachMappings(organisationId) {
  return instance.request({
    url: `mappings/?organisation_id=${organisationId}`,
    method: "GET",
  });
}

export function getBloomreachStatus(organisationId) {
  return instance.request({
    url: `status/?organisation_id=${organisationId}`,
    method: "GET",
  });
}

export function deactivateBloomreach(data) {
  return instance.request({
    url: `deactivate/`,
    method: "POST",
    data,
  });
}

export function updateBloomreachFieldMappings(data) {
  return instance.request({
    url: `field-mappings/`,
    method: "POST",
    data,
  });
}

export function getBloomreachConsentCategories(organisationId) {
  return instance.request({
    url: `consent-categories/?organisation_id=${organisationId}`,
    method: "GET",
  });
}

export function updateBloomreachConsentSettings(data) {
  return instance.request({
    url: `consent-settings/`,
    method: "POST",
    data,
  });
}
